"use strict";
exports.Errors = {
    SRC_LOAD_ERROR: 'SRC_LOAD_ERROR',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};
//# sourceMappingURL=errors.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/types/errors.js
// module id = 2770
// module chunks = 66